// extracted by mini-css-extract-plugin
export default {"expanded":"p6tgrh1o","itemTitle":"cB3loUiF","itemContent":"celVe_Gn","tooltipStyle":"OFOOlc3c"};